import Login from "./components/Login";
import Dashboard from "./containers/Dashboard";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Contacts from "./views/app/Contacts";
import { useSelector } from "react-redux";
import {useEffect, useRef, useState} from "react";
import Messages from "./views/app/Messages";
import VoiceMail from "./views/app/VoiceMail";
import MissedCalls from "./views/app/MissedCalls";
import WaitTime from "./views/app/WaitTime";
import Templates from "./views/app/Templates";
import Reminders from "./views/app/Reminders";
import Profile from "./views/app/Setting/Profile";
import Preferences from "./views/app/Setting/Preferences";
import BlockedNumbers from "./views/app/Setting/BlockedNumbers";
import Employees from "./views/app/Setting/Employees";
import VoicemailDestination from "./views/app/Setting/VoicemailDestination";
import AuditLogs from "./views/app/Setting/AuditLogs";
import Payments from "./views/app/Setting/Payments";
import ForgotPassword from "./components/ForgotPassword/index";
import ChangePassword from "./views/app/Setting/ChangePassword";
import SocketIOClient from "socket.io-client";
import {initPushMessaging} from "./constants/firebase"
import { useDispatch } from "react-redux";
import { SOCKET_URL, BASE_URL } from "./constants/defaultValues";
import {
  fetchAllNotifications,
  fetchNotifications,
  fetchSilentMessage,
  fetchSilentChat,
  fetchSilentVoicemails,
  fetchSilentVoiceChat,
  fetchPreferences, saveFcmToken,
} from "./redux/action";
import * as Sentry from "@sentry/react";
import ImportContacts from "./views/app/Setting/ImportContacts";
import Register from "./components/Register";
import AiAssistant from "./views/app/Setting/AiAssistant";

var socket = SocketIOClient(SOCKET_URL);

function App() {
  const pushInitRef = useRef(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authUser = useSelector((state) => state.authUser);
  let audio = new Audio(`${BASE_URL}/sounds/beep.mp3`);

  const isSafari = () => {
    var chr = window.navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
    var sfri = window.navigator.userAgent.toLowerCase().indexOf("safari") > -1;
    return !chr && sfri;
  };

  const callback_onAutoplayBlocked = () => {
    // do something, for example "show big play button"
    // console.log("blocked 121212121");
    // audio.stop()
    return;
  };

  const _checkAutoPlay = (p) => {
    var s = window["Promise"] ? window["Promise"].toString() : "";
    //var self = this
    if (
      s.indexOf("function Promise()") !== -1 ||
      s.indexOf("function ZoneAwarePromise()") !== -1
    ) {
      p.catch(function (error) {
        console.error("_checkAutoPlay, error:", error);
        if (error.name == "NotAllowedError") {
          // For Chrome/Firefox
          console.error("_checkAutoPlay: error.name:", "NotAllowedError");
          callback_onAutoplayBlocked();
        } else if (error.name == "AbortError" && isSafari()) {
          // Only for Safari
          console.error("_checkAutoPlay: AbortError (Safari)");
          callback_onAutoplayBlocked();
        } else {
          console.error("_checkAutoPlay: happened something else ", error);
          // throw error; // happened something else
        }
      }).then(function () {
        console.log("_checkAutoPlay: then");
        // Auto-play started
      });
    } else {
      console.error(
        "_checkAutoplay: promise could not work in your browser ",
        p
      );
    }
  };

  const showTextNotifications = (accountName) => {
    console.log("Audio loading");
    // audio.play();
    _checkAutoPlay(audio.play());
  };
  const showVoiceNotifications = (accountName) => {
    //if(typeof nvoice !== 'undefined' && nvoice.supported()) nvoice.show();
    // audio.play();
    _checkAutoPlay(audio.play());
  };

  useEffect(() => {
    if (authUser.user) {
      console.log("I am inside hanldeSocket");
      let { activeAccount, user } = authUser;
      let accounts = user?.accounts;

      if (accounts) {
        accounts.forEach((account) => {
          console.log(account.id);
          socket.on(`msg-channel/${account.id}`, (data) => {
            console.log("Inside message channel");
            dispatch(fetchAllNotifications());
            if (account.id == activeAccount) {
              dispatch(fetchNotifications());
              dispatch(fetchSilentMessage());
              dispatch(fetchSilentChat());
            }
            if (data) {
              data = JSON.parse(data);
              if (data.notification) {
                showTextNotifications(account.name);
              }
            }
          });
          socket.on(`voice-mail-channel/${account.id}`, (data) => {
            console.log("Inside message channel");

            dispatch(fetchAllNotifications());
            if (account.id == activeAccount) {
              dispatch(fetchNotifications());
              dispatch(fetchSilentVoicemails());
              dispatch(fetchSilentVoiceChat());
            }
            if (data) {
              data = JSON.parse(data);
              if (data.notification) {
                showVoiceNotifications(account.name);
              }
            }
          });
        });
      }
      dispatch(fetchAllNotifications());
      dispatch(fetchNotifications());
      dispatch(fetchPreferences());
    }
  }, []);

  useEffect(() => {
    var version = localStorage.getItem("version");
    let currentVersion = 4;
    if (version != currentVersion) {
      localStorage.setItem("version", currentVersion);
      localStorage.removeItem("user_id");
      localStorage.removeItem("user");
      if (window.location.pathname != "/register") window.location = "/login";
    }
  }, []);

  useEffect(() => {
    if (!authUser.user) {
      console.log(window.location.pathname);
      if (window.location.pathname == "/register") navigate("/register");
      else navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (!authUser.user) return;
    if (pushInitRef.current) return;
    pushInitRef.current = true;

    initPushMessaging()
        .then(result => {
          if (result && result.token) {
            const res = dispatch(saveFcmToken(result.token));
          }
        })
        .catch(err => {
          console.error("initPushMessaging error:", err);
        });
  }, [authUser.user]);

  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/" element={<Dashboard />}>
          <Route path="contacts" element={<Contacts />} />
          <Route path="messages" element={<Messages />} />
          <Route path="voicemail" element={<VoiceMail />} />
          <Route path="missed-calls" element={<MissedCalls />} />
          <Route path="wait-time" element={<WaitTime />} />
          <Route path="templates" element={<Templates />} />
          <Route path="reminders" element={<Reminders />} />
          <Route path="profile" element={<Profile />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/preferences" element={<Preferences />} />
          <Route path="/blocked-numbers" element={<BlockedNumbers />} />
          <Route path="/employees" element={<Employees />} />
          <Route
            path="/voicemail-destination"
            element={<VoicemailDestination />}
          />
          <Route path="/audit-logs" element={<AuditLogs />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/import-contacts" element={<ImportContacts />} />
          <Route path="/ai-assistant" element={<AiAssistant />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </div>
  );
}

export default Sentry.withProfiler(App);

//export default App;
